import { Divider, PasswordInput, Stack, TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { LoginForm as LoginFormType } from './login.type';

type Props = {
  form: LoginFormType;
  showPassword: boolean;
};

export const LoginForm = ({ form, showPassword }: Props) => {
  const { t } = useTranslation();
  return (
    <Stack gap={24} role="form" aria-label={t('common.form.login_form')}>
      <Divider />
      <TextInput
        label={t('common.form.email')}
        placeholder={t('common.placeholders.email')}
        value={form.values.email}
        onChange={(event) => form.setFieldValue('email', event.currentTarget.value.trim())}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.currentTarget.form?.requestSubmit();
          }
        }}
        error={form.errors.email}
        w="100%"
        autoComplete="email"
        required
      />
      {showPassword && (
        <PasswordInput
          autoFocus
          label={t('common.form.password')}
          placeholder={t('common.placeholders.password')}
          value={form.values.password}
          onChange={(event) => form.setFieldValue('password', event.currentTarget.value)}
          error={form.errors.password}
          w="100%"
          autoComplete="current-password"
          required
        />
      )}
    </Stack>
  );
};
